import { render } from "./MainAreas.vue?vue&type=template&id=abf7047e&scoped=true"
import script from "./MainAreas.vue?vue&type=script&scoped=true&lang=js"
export * from "./MainAreas.vue?vue&type=script&scoped=true&lang=js"

import "./MainAreas.vue?vue&type=style&index=0&id=abf7047e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf7047e"]])

export default __exports__